const makeDivSticky = (selector) => {
	const productImagesModule = rp$(selector);
	const productImagesModuleParent = productImagesModule.parents('.page-builder-layout-column-wrap.full-height-wrapper');
	const isThreeColumnLayout = productImagesModule.parents('.page-builder-layout-column.col-md-4.block-modules.page-builder-layout-column.col-full-height').length > 0;
	if (productImagesModuleParent.length > 0 && isThreeColumnLayout) {
		productImagesModuleParent.css('position', 'sticky');
		productImagesModuleParent.css('top', '20px');
		productImagesModuleParent.css('height', 'unset');
	}
};

const resetMakeDivSticky = (selector) => {
	const productImagesModule = rp$(selector);
	const productImagesModuleParent = productImagesModule.parents('.page-builder-layout-column-wrap.full-height-wrapper');
	const isThreeColumnLayout = productImagesModule.parents('.page-builder-layout-column.col-md-4.block-modules.page-builder-layout-column.col-full-height').length > 0;
	if (productImagesModuleParent.length > 0 && isThreeColumnLayout) {
		productImagesModuleParent.css('position', 'unset');
		productImagesModuleParent.css('top', '0');
		productImagesModuleParent.css('height', 'unset');
	}
};

const resetPurchaseModalStyles = (isReset = false) => {
	const purchaseModuleClass = '.product-purchase-module';
	if (isReset) {
		resetMakeDivSticky(purchaseModuleClass);
	} else {
		makeDivSticky(purchaseModuleClass);
	}
};

module.exports = {
	makeDivSticky,
	resetMakeDivSticky,
	resetPurchaseModalStyles
};